import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from '../../Routes';
import GA from '../../googleAnalytics';

import './styles.css';

const App = () => (
  <div className="App">
    <BrowserRouter>
      {GA.init() && <GA.RouteTracker />}
      <Routes />
    </BrowserRouter>
  </div>
);

export default App;
